/**
 * Marketing tab — currently just hosts site-wide announcements but kept as
 * its own component so future marketing surfaces (banners, A/B copy slots,
 * coupon broadcasts) drop in without touching AdminDashboardPage.
 */
import { adminApi } from "../../lib/api";
import { AnnouncementsPanel } from "./AnnouncementsPanel";

export const MarketingTab = () => (
  <AnnouncementsPanel api={adminApi} />
);
